<script setup>
import SecondaryHeading from '@/components/shared/page/SecondaryHeading.vue'

//Emits and props
defineProps({
  header: {
    type: String,
    default: '',
  },
  subheader: {
    type: String,
    default: '',
  },
  isCompact: {
    type: Boolean,
    default: false,
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div
    ref="block"
    :class="$style.block"
  >
    <div
      v-if="header"
      :class="$style.header"
    >
      <SecondaryHeading
        tag="h2"
        :text="header"
      />
    </div>
    <div :class="$style.content">
      <slot />
    </div>
  </div>
</template>

<style module>
.block {
  & + & {
    margin-top: 1.5rem;
    border-top: 1px solid var(--color-borders);
    padding-top: 1rem;
  }
}
.header {
  margin-bottom: 1rem;
}
</style>
